import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../global.service';

@Component({
	selector: 'admin-statistika',
	templateUrl: './admin-statistika.component.html',
	styleUrls: ['./admin-statistika.component.css']
})
export class AdminStatistikaComponent implements OnInit {

	loading : boolean = false; 
	studijskiProgrami : any = [];
	@Output() onCancel = new EventEmitter<any>();

	constructor(public globalSrvc: GlobalService, public http : HttpClient) { }

	ngOnInit() {
		this.ucitajStudStatistiku();
	}

	ucitajStudStatistiku(){
		this.loading = true; 
		setTimeout(() => {
			this.http.get('prijave/fakulteti/statistika', {params: {}})
			.subscribe(data => {
				this.studijskiProgrami = data;
				this.loading = false;
			},
			error => {
				this.loading = false;
			});	
		}, 1000);
	}

	eksportPDF(outType, file){
        //console.log(this.ucenik);
        this.loading = true;
        let url = 'getReport/statistika';
        
		this.http.get(url, {params : {'outType' : outType, 'file' : file}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, outType);
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja izvjestaja');
        });    
    }

	cancel(){
		if (this.onCancel)
			this.onCancel.emit(null);
	}
}
